import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, forkJoin, empty } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { StorageManagerService, LLFormService, CompanyContactService } from '../../shared/services/index';
import { LCRFormService } from '../services/lcr-form.service';

@Injectable()
export class LCRFormResolverService implements Resolve<any> {
    revisionId: string;
    customerGuid: string;

  constructor (private lcrService: LCRFormService, private storageManagerService: StorageManagerService,
      private llservice: LLFormService, private companyService: CompanyContactService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const revisionId = route.params.revisionId;
    const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');

    if (currentCustomerStr) {
        const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
        if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
        }
    }

    const retVal = forkJoin([
            revisionId ? this.lcrService.getLCRFormById(revisionId) : of(null),
            this.llservice.getSSDPVocabularies(),
            this.llservice.getLCompanyTypesByCustomerGuid(this.customerGuid),
            this.companyService.getBusinessCategories(false),
            revisionId ? this.lcrService.getRevisionHistory(revisionId) : of(null),
            this.companyService.getCountries()]
        )
        .pipe(catchError(err => of({ error: err })));

        return retVal;
    }
}
